import React, { FocusEvent } from 'react';

import Grid from '@mui/material/Grid2';
import { FormikErrors, FormikTouched } from 'formik';

import AcCard from 'components/AcCard/AcCard';

import { QUANTITY_FORMAT_FIELDS } from '../../StoreSettings.consts';
import { EOfferFormatKey, IQuantityFormat } from '../../StoreSettings.types';

import { QuantityFormatField } from './components/QuantityFormatField';

interface IQuantityFormatCardProps {
  title: string;
  name: EOfferFormatKey;
  quantityFormat: IQuantityFormat;
  isFetching: boolean;
  touched?: FormikTouched<IQuantityFormat>;
  errors?: FormikErrors<IQuantityFormat>;
  onFieldChange: (fieldPath: string, rawValue: string) => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

export const QuantityFormatCard = ({
  title,
  name,
  quantityFormat,
  isFetching,
  touched,
  errors,
  onFieldChange,
  onBlur
}: IQuantityFormatCardProps): React.ReactElement => (
  <AcCard stackContainer={false} title={title}>
    <Grid container rowSpacing={2} columnSpacing={1.5}>
      {QUANTITY_FORMAT_FIELDS.map((descriptor) => (
        <Grid size={descriptor.gridSize} key={descriptor.key}>
          <QuantityFormatField
            descriptor={descriptor}
            name={name}
            quantityFormat={quantityFormat}
            isFetching={isFetching}
            touched={touched}
            errors={errors}
            onFieldChange={onFieldChange}
            onBlur={onBlur}
          />
        </Grid>
      ))}
    </Grid>
  </AcCard>
);
